/* !! DO NOT EDIT manually, this file is AUTO-GENERATED. Any edits to the file will be overwritten during the build. Edits should be made to the SVG with a matching name */ import * as React from "react";
const SvgUp = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 2048 2048",
        width: "1em",
        height: "1em",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "m1875 1037-787-787v1798H960V250l-787 787-90-90L1024 6l941 941-90 90z"
    }));
export default SvgUp;
